import React, { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';

import { CommissionsCreateConditionsHeader } from './CommissionsCreateConditionsHeader';
import { CommissionsCreateLadderBase } from './CommissionsCreateLadderBase';
import { CommissionsCreateLadderCalculationMethod } from './CommissionsCreateLadderCalculationMethod';
import { CommissionsCreateLadderSteps } from './CommissionsCreateLadderSteps';
import {
  CommissionsBaseForm,
  CommissionsBaseFormValues,
} from '../components/CommissionsBaseForm/CommissionsBaseForm';
import {
  CommissionsConditionsForm,
  CommissionsConditionsFormValues,
} from '../components/CommissionsConditionsForm';
import { useIsAllowedLadder } from './hooks/useIsAllowedLadder';

export type CommissionRateFormValues = {
  percent: string | null;
  fix: string | null;
  min: string | null;
  max: string | null;
};

export type CommissionStepFormValues = {
  stepNumber: number;
  thresholdFrom: string | null;
  isLastStep?: boolean;
  thresholdTo: string | null;
  commissionRate: CommissionRateFormValues;
};

export type CommissionLadderFormValues = {
  periodType: string | null;
  ladderType: string | null;
  steps: CommissionStepFormValues[] | undefined;
};

export type CommissionsCreateFormValues = CommissionsBaseFormValues & {
  isLadder?: boolean;
  rate: CommissionsConditionsFormValues & {
    zeroed: boolean;
  };
  calculationMethod?: string | null;
  ladder?: CommissionLadderFormValues | null;
};

export const CommissionsCreateForm = () => {
  const { watch, setValue, unregister } = useFormContext<CommissionsCreateFormValues>();
  const transactionTypesWatched = watch('transactionTypes');
  const isLadderWatched = watch('isLadder');
  const { isAllowedLadder } = useIsAllowedLadder(transactionTypesWatched);

  useEffect(() => {
    if (!isAllowedLadder) {
      setValue('isLadder', false);
      unregister('ladder');
    }
  }, [isAllowedLadder]);

  return (
    <Box sx={{ paddingY: '24px', width: '100%' }}>
      <CommissionsBaseForm />
      <CommissionsCreateConditionsHeader />
      {isLadderWatched ? <CommissionsCreateLadderBase /> : <CommissionsConditionsForm />}
      {isLadderWatched && <CommissionsCreateLadderSteps />}
      {isLadderWatched && <CommissionsCreateLadderCalculationMethod />}
    </Box>
  );
};
